import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 5H3v14h18V5zm-2 12H5V7h14v10z"
}), 'Crop54Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Crop54Sharp.js
// module id = 2997
// module chunks = 2